const ErrorMessage = ({ message, show }) => {
    if (!show || !message) return null;
    return (
        <div className="animate-in" style={{ marginTop: '4px' }}>
            <small className="text-danger fw-bold" style={{ fontSize: '10px' }}>
                * {message}
            </small>
        </div>
    );
};

export default ErrorMessage;